import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _isEmpty from 'lodash/isEmpty';
import { getHeaders, getBaseURL } from '@tekion/tekion-base/services/MediaRepository';
import FileReader from '@tekion/tekion-base/utils/File.reader';
import { isVideo } from '@tekion/tekion-base/helpers/media.helper';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { fetchMediaList } from './MediaUploader.actions';
import { API_CALL_STATUS } from './mediaUploader.constants';
var retrieveMediaList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var formData, mediaList;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          formData = new FormData();
          formData.append('file', file[0]);
          _context.next = 4;
          return fetchMediaList(formData);
        case 4:
          mediaList = _context.sent;
          return _context.abrupt("return", mediaList);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function retrieveMediaList(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getMediaConfig = function getMediaConfig(params) {
  var config = {
    baseURL: getBaseURL(),
    headers: getHeaders()
  };
  return !_isEmpty(params) ? _objectSpread(_objectSpread({}, config), {}, {
    params: params
  }) : config;
};
function getCallStatus(callResponse) {
  return callResponse.status === API_CALL_STATUS.SUCCESS ? API_CALL_STATUS.SUCCESS : API_CALL_STATUS.FAILED;
}
function getTosterType(callStatus) {
  return callStatus === API_CALL_STATUS.SUCCESS ? 'success' : 'error';
}
function getVideoEncodingParams(_ref2) {
  var file = _ref2.file;
  return isVideo(FileReader.getFileType(file)) ? {
    encodeFormat: 'MP4'
  } : EMPTY_OBJECT;
}
export { retrieveMediaList, getMediaConfig, getCallStatus, getTosterType, getVideoEncodingParams };